// 时间线接口
import axios from '@src/public/utils/request';

export const getTimelineList = ({ id, page, size = 10, party, highlights = 0, order }) => {
    return axios.get(`/timeline/front/api/timelines/${id}`, {
        params: { page, size, party, highlights, order },
    });
};
